export const ERROR_LOGGER_START = 'ERROR_LOGGER_START';
export const ERROR_LOGGER_STOP = 'ERROR_LOGGER_STOP';
export const ERROR_LOGGER_ADD_ERROR = 'ERROR_LOGGER_ADD_ERROR';
export const ERROR_LOGGER_RESET = 'ERROR_LOGGER_RESET';
